var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitch2Way({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.73,9.91c-1.16,0-2.1-0.94-2.1-2.1s0.94-2.1,2.1-2.1s2.1,0.94,2.1,2.1S8.89,9.91,7.73,9.91z M7.73,6.21 c-0.88,0-1.6,0.72-1.6,1.6c0,0.88,0.72,1.6,1.6,1.6c0.88,0,1.6-0.72,1.6-1.6C9.33,6.92,8.61,6.21,7.73,6.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "9.13,6.5 8.69,6.26 11.27,1.53 13.44,2.61 13.22,3.06 11.47,2.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "4.71,14.47 2.56,13.36 2.78,12.91 4.51,13.8 6.91,9.53 7.35,9.78  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch2Way);
export default __webpack_public_path__ + "static/media/Switch2Way.fbd488723b1f5886c08d5e0a71a457d9.svg";
export { ForwardRef as ReactComponent };